// extracted by mini-css-extract-plugin
export default {"container":"Products_container__w3S6m","products":"Products_products__MAvTu","menu":"Products_menu__BbqtZ","list":"Products_list__L-3oh","product":"Products_product__WYAC5"};